import types from './types';

export const getPrompts = () => ({
  type: types.GET_PROMPTS,
});
export const getPromptsSuccess = (payload) => ({
  type: types.GET_PROMPTS_SUCCESS,
  payload,
});
